export const envisionOrgId = [{
  area: 'CINCI',
  orgId: '4000825'
},
{
  area: 'DALL',
  orgId: '4000631'
},
{
  area: 'INDI',
  orgId: '4000714'
},
{
  area: 'WASH',
  orgId: '4000828'
},
{
  area: 'RALE',
  orgId: '4000826'
},
{
  area: 'CLEVE',
  orgId: '4000829'
},
{
  area: 'NASH',
  orgId: '4000827'
},
{
  area: 'HOUS',
  orgId: '4000947'
},
{
  area: 'AUST',
  orgId: '4000948'
},
{
  area: 'JAX',
  orgId: '4000946'
}];
